<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-02-23 10:19:44
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-20 11:06:35
-->
<template>
	<div class="talent-info" @click="showdetailDrawer">
		<el-image :src="talentInfo.head" />
		<div class="right">
			<div>{{ talentInfo.anchor_name }}</div>
			<div class="number">
				<platform-icon :platformId="talentInfo.platform_id" class="mr-4"></platform-icon>
				<rd-text v-if="$isPlatOr(talentInfo.platform_id, ['Dy', 'Ks'])">
					{{ talentInfo.platform_id | formatPlatformName('unify') }}：{{ talentInfo.anchor_account }}
				</rd-text>
				<rd-text v-if="$isSp(talentInfo.platform_id)">
					{{ talentInfo.platform_id | formatPlatformName('unify') }}：{{ talentInfo.anchor_uid }}
				</rd-text>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'talentInfo',
	props: {
		talentInfo: {
			type: Object,
			default: _ => ({}),
		},
	},
	methods: {
		showdetailDrawer() {
			this.$emit('showdetailDrawer', this.talentInfo.anchor_id);
		},
	},
	components: {},
};
</script>

<style lang="less" scoped>
.talent-info {
	display: flex;
	cursor: pointer;
	color: #333;
	&:hover {
		color: @color-primary;
	}
	.el-image {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		margin-top: 4px;
	}
	.right {
		margin-left: 8px;
		font-size: 14px;
		flex: 1;
		overflow: hidden;
		.number {
			display: flex;
			align-items: center;
		}
	}
}
</style>
